import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { mapFirebaseError } from '../functions/classes';
import { Navbar2 } from '../functions/ui';
import { PiEye, PiEyeSlash } from 'react-icons/pi';
import '../webapp.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [generalError, setGeneralError] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // Input validation
  const validateInputs = () => {
    let valid = true;

    if (!email) {
      setEmailError('Email is required');
      valid = false;
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setEmailError('Please enter a valid email');
        valid = false;
      } else {
        setEmailError('');
      }
    }

    if (!password) {
      setPasswordError('Password is required');
      valid = false;
    } else {
      setPasswordError('');
    }

    return valid;
  };

  const handleLogin = async (e) => {
    e.preventDefault(); // Prevent form submission
    if (validateInputs()) {
      setLoading(true);
      try {
        const auth = getAuth();
        await signInWithEmailAndPassword(auth, email, password);
        navigate('/dashboard');
      } catch (err) {
        const errorMessage = mapFirebaseError(err.code) || 'An unknown error occurred';
        setGeneralError(errorMessage);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <>
      <Navbar2 />
      <div className="getaccess-wrapper">
        <div className="getaccess-container">
          <h2>Log in</h2>
          <form onSubmit={handleLogin}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="text"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onFocus={() => setEmailError('')}
              />
              {emailError && <p className="error-message">{emailError}</p>}  {/* Show email error */}
            </div>
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className='passwordbox'>
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onFocus={() => { setPasswordError(''); setGeneralError(''); }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="showhide"
                  tabIndex={-1}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? <PiEyeSlash /> : <PiEye />}
                </button>
              </div>
              {passwordError && <p className="error-message">{passwordError}</p>}  {/* Show password error */}
              {generalError && <p className="error-message">{generalError}</p>}  {/* Show general error */}
            </div>
            <button type="submit" className='full-button' disabled={loading}>{loading ? 'Logging in...' : 'Log in'}</button>
          </form>
          <div className="sign-up-link">
            Don't have an account?{' '}
            <Link to="/signup" className="sign-up-link-text">Create one</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;

//Done